import $ from "jquery";

$(".faq-section").on("click", ".question-container:not(.open)", (e) => {
  if ($(":animated").length) {
    return false;
  }

  const answer = $(e.currentTarget).children(".faq-answer");

  answer.css("display", "block");

  const height = answer.css("height");

  answer.css("height", 0);

  $(e.currentTarget).css("box-shadow", "0 0 15px 0 rgba(0,0,0,0.16)");

  answer.animate(
    {
      height,
    },
    140,
    () => {
      answer.css("height", "auto");
      $(e.currentTarget).addClass("open");
    },
  );
});

$(".faq-section").on("click", ".question-container.open", (e) => {
  if ($(":animated").length) {
    return false;
  }

  const answer = $(e.currentTarget).children(".faq-answer");

  answer.animate(
    {
      height: 0,
    },
    140,
    () => {
      answer.css("display", "none");
      answer.css("height", "auto");
      $(e.currentTarget).removeClass("open");
      $(e.currentTarget).css("box-shadow", "0 0 3px 0 rgba(0,0,0,0.16)");
    },
  );
});
